import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { colors } from '../../../constants/colors';
import { fontSize, fontFamily } from '../../../constants/text';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import Circle from '../../Account/Profile/Circle';

const ActionText = styled.span`
  font-size: ${fontSize.default};
  ${props => css`
    color: ${props.istextlink ? colors.blueJayWay : colors.squid};
  `}
`;

const Spacer = styled.div`
  width: 4px;
  height: 40px;
`;

const ActionItem = styled(ListItem)`
  .listItemRoot {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  svg {
    padding: 8px;
    fill: ${colors.lightText};
  }
`;

class DrawerAction extends PureComponent {
  static propTypes = {
    icon: PropTypes.node,
    actionText: PropTypes.string,
    showArrow: PropTypes.bool,
    id: PropTypes.string,
    onClick: PropTypes.func,
    textLink: PropTypes.bool,
  };

  static defaultProps = {
    showArrow: true,
    textLink: false,
  };

  render = () => {
    const { icon, actionText, showArrow, id, onClick, textLink } = this.props;
    return (
      <ActionItem key={id} onClick={onClick} dense button>
        {icon ? <Circle backgroundColor={colors.theWhiteAlbum}>{icon}</Circle> : <Spacer />}
        <ListItemText primary={<ActionText istextlink={textLink}>{actionText}</ActionText>} />
        {showArrow && (
          <ListItemSecondaryAction>
            <IconButton aria-label="Delete">
              <ChevronRightIcon onClick={onClick} />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </ActionItem>
    );
  };
}

export default DrawerAction;
